import angular from 'angular';
import opportunitiesTable from './opportunitiesTable';
import insuranceOpportunities from './insuranceOpportunities';

export default angular
  .module('insuranceQuoteOpportunities.scenes.components', [])
  .component('opportunitiesTable', opportunitiesTable)
  .component('insuranceOpportunities', insuranceOpportunities).name;
